// extracted by mini-css-extract-plugin
export default {"wrap":"jF-z","subtitle":"kF-z","contentWrap":"lF-z","imgWrap":"mF-z","heading":"nF-z","copy":"oF-z"};